module.exports = __webpack_public_path__ + "static/kbusiness_1d-8377e0aa0c2c6635ca291748e62059e0.mp4";